import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

export const CandlestickChart = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="19.998"
    height="18.003"
    viewBox="0 0 19.998 18.003"
    fill="currentColor"
  >
    <g transform="translate(1 0.001)">
      <g>
        <path
          d="M8983,16741v-2h-4v-2h4v-2h6v2h8v2h-8v2Zm1-7v-2h-5v-2h5v-2h8v2h5v2h-5v2Zm4-7v-2h-9v-2h9v-2h7v2h2v2h-2v2Z"
          transform="translate(16740 -8979) rotate(90)"
        />
      </g>
    </g>
  </Icon>
);

export const ZoneChart = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="12.98"
    viewBox="0 0 20 12.98"
    fill="currentColor"
  >
    <path
      d="M3.5,18.49l6-6.01,4,4L22,6.92,20.59,5.51,13.5,13.48l-4-4L2,16.99Z"
      transform="translate(-2 -5.51)"
    />
  </Icon>
);



// WEBPACK FOOTER //
// ./src/components/Icons/Trade/ChartTypeTabs.js